<template>
  <div id="Userlist">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">用戶列表</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">用戶</li>
              <li class="breadcrumb-item active">用戶列表</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div id="user" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-sm-10"></div>
          <div class="col-sm-2"></div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <div class="card">
              <div class="demo-input-size row margs">
                <el-input
                  class="col-lg-2"
                  placeholder="用戶名稱/電郵"
                  @input="search()"
                  v-model="filterParams.displayName"
                ></el-input>
                <el-select
                  class="col-lg-1"
                  v-model="filterParams.sex"
                  placeholder="請選擇性別"
                  @change="search()"
                  clearable
                >
                  <el-option label="Male" value="Male"></el-option>
                  <el-option label="Female" value="Female"></el-option>
                  <el-option label="Unknown" value="Unknown"></el-option>
                </el-select>
                <el-select
                  class="col-lg-1"
                  v-model="filterParams.userType"
                  placeholder="用戶類型"
                  @change="search()"
                  clearable
                >
                  <el-option label="ADMIN" value="ADMIN"></el-option>
                  <el-option label="USER" value="USER"></el-option>
                </el-select>
                <el-select
                  class="col-lg-1"
                  v-model="filterParams.roleNameId"
                  placeholder="請選擇角色"
                  @change="search()"
                  clearable
                >
                  <el-option
                    v-for="role in roleList"
                    v-bind:key="role.id"
                    :label="role.sgL_RoleName"
                    :value="role.id"
                  ></el-option>
                </el-select>

                <el-select
                  class="col-lg-1"
                  v-model="filterParams.area"
                  placeholder="請選擇地區"
                  @change="search()"
                  clearable
                >
                  <el-option label="中國大陸" value="中國大陸"></el-option>
                  <el-option label="中國香港" value="中國香港"></el-option>
                  <el-option label="中國澳門" value="中國澳門"></el-option>
                  <el-option label="中國台灣" value="中國台灣"></el-option>
                  <el-option
                    label="台灣省-臺北市"
                    value="台灣省-臺北市"
                  ></el-option>
                  <el-option
                    label="台灣省-新北市"
                    value="台灣省-新北市"
                  ></el-option>
                  <el-option
                    label="台灣省-桃園市"
                    value="台灣省-桃園市"
                  ></el-option>
                  <el-option
                    label="台灣省-臺中市"
                    value="台灣省-臺中市"
                  ></el-option>
                  <el-option
                    label="台灣省-臺南市"
                    value="台灣省-臺南市"
                  ></el-option>
                  <el-option
                    label="台灣省-高雄市"
                    value="台灣省-高雄市"
                  ></el-option>
                  <el-option
                    label="台灣省-基隆市"
                    value="台灣省-基隆市"
                  ></el-option>
                  <el-option
                    label="台灣省-新竹市"
                    value="台灣省-新竹市"
                  ></el-option>
                  <el-option
                    label="台灣省-嘉義市"
                    value="台灣省-嘉義市"
                  ></el-option>
                  <el-option
                    label="台灣省-新竹縣"
                    value="台灣省-新竹縣"
                  ></el-option>
                  <el-option
                    label="台灣省-苗栗縣"
                    value="台灣省-苗栗縣"
                  ></el-option>
                  <el-option
                    label="台灣省-彰化縣"
                    value="台灣省-彰化縣"
                  ></el-option>
                  <el-option
                    label="台灣省-南投縣"
                    value="台灣省-南投縣"
                  ></el-option>
                  <el-option
                    label="台灣省-云林縣"
                    value="台灣省-云林縣"
                  ></el-option>
                  <el-option
                    label="台灣省-嘉義縣"
                    value="台灣省-嘉義縣"
                  ></el-option>
                  <el-option
                    label="台灣省-屏東縣"
                    value="台灣省-屏東縣"
                  ></el-option>
                  <el-option
                    label="台灣省-宜蘭縣"
                    value="台灣省-宜蘭縣"
                  ></el-option>
                  <el-option
                    label="台灣省-花蓮縣"
                    value="台灣省-花蓮縣"
                  ></el-option>
                  <el-option
                    label="台灣省-臺東縣"
                    value="台灣省-臺東縣"
                  ></el-option>
                  <el-option
                    label="台灣省-澎湖縣"
                    value="台灣省-澎湖縣"
                  ></el-option>
                  <el-option label="海外地區" value="海外地區"></el-option>
                  <el-option label="未填寫" value="未填寫"></el-option>
                </el-select>

                <el-select
                  class="col-lg-1"
                  v-model="filterParams.IsRecepte"
                  placeholder="接受宣傳"
                  @change="search()"
                  clearable
                >
                  <el-option label="是" value="true"></el-option>
                  <el-option label="否" value="false"></el-option>
                </el-select>
                <el-select
                  class="col-lg-1"
                  v-model="filterParams.accountStatus"
                  placeholder="用戶狀態"
                  @change="search()"
                  clearable
                >
                  <el-option label="SUCCESS" value="SUCCESS"></el-option>
                  <el-option label="CANCAL" value="CANCAL"></el-option>
                  <el-option label="FORBIDDEN" value="FORBIDDEN"></el-option>
                </el-select>
                <div class="block col-lg-2">
                  <el-date-picker
                    @change="search()"
                    v-model="filterParams.registDay"
                    type="date"
                    placeholder="註冊日期"
                  ></el-date-picker>
                </div>
              </div>
              <div class="card-body">
                <el-table
                  :data="GetListUser"
                  border
                  row-key="id"
                  @sort-change="sortsize"
                >
                  <el-table-column
                    label="ID"
                    fixed
                    width="100"
                    prop="id"
                  ></el-table-column>
                  <el-table-column width="100" label="用戶頭像">
                    <template slot-scope="scoped">
                      <img
                        class="user-logo"
                        slot="reference"
                        :src="`https://api.soonnet.org/Account/Acc_Resources/${scoped.row.id}/Userlogo_Smail.jpg`"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="100"
                    label="用戶名稱"
                    prop="sgL_UsersName"
                  ></el-table-column>
                  <el-table-column
                    width="100"
                    label="性別"
                    prop="sgL_Sex"
                  ></el-table-column>
                  <el-table-column
                    width="100"
                    label="角色"
                    prop="sgL_Role"
                  ></el-table-column>
                  <el-table-column
                    label="用戶類型"
                    prop="sgL_UsersType"
                  ></el-table-column>
                  <el-table-column
                    label="出生日期"
                    width="160"
                    prop="sgL_BirthF"
                  ></el-table-column>
                  <el-table-column
                    width="140"
                    label="所在地區"
                    prop="sgL_Area"
                  ></el-table-column>
                  <el-table-column
                    label="相簿使用量"
                    width="140"
                    prop="SizeSpanCount"
                    sortable="custom"
                  >
                    <template slot-scope="scoped">
                      <el-progress
                        :text-inside="true"
                        :stroke-width="22"
                        :percentage="scoped.row.sgL_SelfNetworkDiskF"
                        status="success"
                        v-if="scoped.row.sgL_SelfNetworkDiskF < 95"
                      ></el-progress>
                      <el-progress
                        :text-inside="true"
                        :stroke-width="20"
                        :percentage="scoped.row.sgL_SelfNetworkDiskF"
                        status="exception"
                        v-else
                      ></el-progress>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="200"
                    label="註冊電郵"
                    prop="sgL_LoginEmail"
                  ></el-table-column>
                  <el-table-column
                    width="140"
                    label="註冊日期"
                    prop="sgL_CreateTimeF"
                  ></el-table-column>
                  <!-- <el-table-column label="用户状态" prop="sgL_AccountStatus"> -->
                  <!-- </el-table-column> -->
                  <el-table-column
                    label="最後訪問時間"
                    prop="sgL_LastLoginTimersF"
                  ></el-table-column>
                  <el-table-column
                    label="接收宣傳資訊"
                    prop="sgL_IsRecepteF"
                  ></el-table-column>
                  <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                      <el-button
                        type="primary"
                        size="mini"
                        @click="openUpdateUser(scope.row.id)"
                        >編輯資料及权限</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- /.card-body -->
            </div>
            <div class="row">
              <div class="col-lg-4 offset-lg-7">
                <!--  引用分页组件 -->
                <pagination
                  v-if="pageParams.pageshow"
                  :currentPage="pageParams.currentPage"
                  :total="pageParams.total"
                  :limit="pageParams.limit"
                  :small="true"
                  @handleCurrentChange="handleCurrentChange"
                  @handleSizeChange="handleSizeChange"
                />
              </div>
            </div>
          </div>
          <!-- /.col-12 -->
        </div>
        <el-dialog title="編輯用戶資料" :visible.sync="IsUpdateUser">
          <el-form :model="userModel" label-width="140px" ref="userModel">
            <el-form-item label="用戶ID">
              <el-input v-model="userModel.id" disabled></el-input>
            </el-form-item>
            <el-form-item label="用戶名稱">
              <el-input v-model="userModel.sgL_UsersName"></el-input>
            </el-form-item>
            <el-form-item label="用戶密碼">
              <el-input
                v-model="userModel.sgL_LoginPassword"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item label="角色">
              <el-select
                :disabled="roleselect"
                v-model="userModel.sgL_RoleIdInt"
                placeholder="請選擇角色"
              >
                <el-option label="請選擇" :value="0"></el-option>
                <el-option
                  v-for="role in roleList"
                  v-bind:key="role.id"
                  :label="role.sgL_RoleName"
                  :value="role.id"
                ></el-option>
              </el-select>
              <el-alert
                title="(必須為管理員賬戶設置角色)"
                type="warning"
              ></el-alert>
            </el-form-item>
            <el-form-item label="请选择用户类型">
              <el-select
                :disabled="roleselect"
                v-model="userModel.sgL_UsersType"
                placeholder="用戶類型"
                clearable
              >
                <el-option label="ADMIN" value="ADMIN"></el-option>
                <el-option label="USER" value="USER"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="空間">
              <el-select
                v-model="userModel.sgL_NetworkDiskCapacity"
                placeholder="空間"
                clearable
              >
                <el-option
                  v-for="item in 30"
                  :key="item"
                  :label="`${1024 * item}G`"
                  :value="`${1024 * item}`"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="性別">
              <el-select v-model="userModel.sgL_Sex" placeholder="請選擇">
                <el-option label="Male" value="Male"></el-option>
                <el-option label="Female" value="Female"></el-option>
                <el-option label="Unknown" value="Unknown"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="出生日期">
              <el-date-picker
                v-model="userModel.sgL_Birth"
                type="date"
                placeholder="選擇日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="所在地區">
              <el-select v-model="userModel.sgL_Area" placeholder="請選擇">
                <el-option label="中國大陸" value="中國大陸"></el-option>
                <el-option label="中國香港" value="中國香港"></el-option>
                <el-option label="中國澳門" value="中國澳門"></el-option>
                <el-option label="中國台灣" value="中國台灣"></el-option>
                <el-option
                  label="台灣省-臺北市"
                  value="台灣省-臺北市"
                ></el-option>
                <el-option
                  label="台灣省-新北市"
                  value="台灣省-新北市"
                ></el-option>
                <el-option
                  label="台灣省-桃園市"
                  value="台灣省-桃園市"
                ></el-option>
                <el-option
                  label="台灣省-臺中市"
                  value="台灣省-臺中市"
                ></el-option>
                <el-option
                  label="台灣省-臺南市"
                  value="台灣省-臺南市"
                ></el-option>
                <el-option
                  label="台灣省-高雄市"
                  value="台灣省-高雄市"
                ></el-option>
                <el-option
                  label="台灣省-基隆市"
                  value="台灣省-基隆市"
                ></el-option>
                <el-option
                  label="台灣省-新竹市"
                  value="台灣省-新竹市"
                ></el-option>
                <el-option
                  label="台灣省-嘉義市"
                  value="台灣省-嘉義市"
                ></el-option>
                <el-option
                  label="台灣省-新竹縣"
                  value="台灣省-新竹縣"
                ></el-option>
                <el-option
                  label="台灣省-苗栗縣"
                  value="台灣省-苗栗縣"
                ></el-option>
                <el-option
                  label="台灣省-彰化縣"
                  value="台灣省-彰化縣"
                ></el-option>
                <el-option
                  label="台灣省-南投縣"
                  value="台灣省-南投縣"
                ></el-option>
                <el-option
                  label="台灣省-云林縣"
                  value="台灣省-云林縣"
                ></el-option>
                <el-option
                  label="台灣省-嘉義縣"
                  value="台灣省-嘉義縣"
                ></el-option>
                <el-option
                  label="台灣省-屏東縣"
                  value="台灣省-屏東縣"
                ></el-option>
                <el-option
                  label="台灣省-宜蘭縣"
                  value="台灣省-宜蘭縣"
                ></el-option>
                <el-option
                  label="台灣省-花蓮縣"
                  value="台灣省-花蓮縣"
                ></el-option>
                <el-option
                  label="台灣省-臺東縣"
                  value="台灣省-臺東縣"
                ></el-option>
                <el-option
                  label="台灣省-澎湖縣"
                  value="台灣省-澎湖縣"
                ></el-option>
                <el-option label="海外地區" value="海外地區"></el-option>
                <el-option label="未填寫" value="未填寫"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="郵箱">
              <el-input v-model="userModel.sgL_LoginEmail"></el-input>
            </el-form-item>
            <el-form-item label="藍Ｖ認證">
              <el-checkbox v-model="userModel.photographerAuth"></el-checkbox>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="IsUpdateUser = false">取 消</el-button>
            <el-button type="primary" @click="open(userModel.id)"
              >保 存</el-button
            >
            <!-- @click="EditUserById()" -->
          </div>
        </el-dialog>
        <el-dialog> </el-dialog>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content -->
  </div>
</template>
<script>
import { Message } from "element-ui";
import pagination from "../common/Page";
export default {
  data() {
    return {
      userListModel: null, //用戶列表
      roleList: null,
      IsUpdateUser: false,
      currentUserId: null,
      adminUser: null,
      roleselect: false,
      userModel: {
        id: "",
        sgL_UsersName: "",
        sgL_LoginPassword: "",
        sgL_Sex: "",
        sgL_RoleIdInt: null,
        sgL_Birth: "",
        sgL_Area: "",
        sgl_AccountStatus: "",
        sgl_NetworkDiskCapacity: "",
        sgL_UsersType: "",
        sgL_LoginEmail: "",
        photographerAuth: "",
      },
      pageParams: {
        pageshow: true,
        currentPage: 1, //當前頁
        total: 0, //總條數
        limit: 10, //顯示條數
      },
      filterParams: {
        Sorting: "Id",
        displayName: "",
        sex: "",
        birth: "",
        userCountOrder: null,
        area: "",
        registDay: "",
        lastloginDay: "",
        roleNameId: "",
        userType: "",
        accountStatus: "",
        IsRecepte: "",
      },
    };
  },
  created() {
    this.getUserList();
    this.getRoleList();
    this.adminUser = this.$store.getters.getAdminUser;
  },

  methods: {
    getUserList() {
      let params = {
        displayName: this.filterParams.displayName,
        sex: this.filterParams.sex,
        sortASC: this.filterParams.userCountOrder,
        Sorting: this.filterParams.Sorting,
        // birth: filterParams.birth,
        areas: this.filterParams.area,
        registDay: this.filterParams.registDay,
        // lastloginDay: filterParams.lastloginDay,
        roleNameId: this.filterParams.roleNameId, //角色id
        userType: this.filterParams.userType, //用戶類型
        accountStatus: this.filterParams.accountStatus, //賬戶狀態
        IsRecepte: this.filterParams.IsRecepte,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
      };
      this.$api.permissionApi.GetUserList(params).then((res) => {
        if (res.data.success) {
          this.userListModel = res.data.result.items;
          this.pageParams.total = res.data.result.totalCount;
        }
      });
    },
    sortsize(val) {
      this.filterParams.userCountOrder = val.order;
      this.filterParams.Sorting = val.prop;
      if (val.order == null) {
        this.filterParams.Sorting = "Id";
      }
      this.getUserList();
    },
    getRoleList() {
      this.$api.permissionApi.GetAllRole().then((res) => {
        if (res.data.success) {
          this.roleList = res.data.result.items;
        }
      });
    },
    open(id) {
      this.$prompt("請輸入當前管理員帳戶的密碼", "提示", {
        confirmButtonText: "確定",
        inputType: "password",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          let admin = this.$store.getters.getAdminUser;
          let params = {
            name: admin.displayName,
            pwd: value,
          };
          this.$store.dispatch("adminLogin", params).then((res) => {
            if (res) {
              this.EditUserById();
            } else {
              Message({
                type: "error",
                message: "密碼輸入錯誤",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消輸入",
          });
        });
    },
    //打開修改用戶資料框
    openUpdateUser(id) {
      this.currentUserId = id;
      if (this.currentUserId == this.adminUser.userId) {
        this.roleselect = true;
      } else {
        this.roleselect = false;
      }
      let params = {
        id: id,
      };
      this.$api.permissionApi.getUser(params).then((res) => {
        if (res.data.success) {
          this.userModel = res.data.result;
          this.IsUpdateUser = true;
        }
      });
    },
    //修改用戶資料
    EditUserById() {
      //调用移除精选的方法
      let params = {
        id: this.currentUserId,
        sgL_UsersName: this.userModel.sgL_UsersName,
        sgL_LoginPassword: this.userModel.sgL_LoginPassword,
        sgL_Sex: this.userModel.sgL_Sex,
        sgL_UsersType: this.userModel.sgL_UsersType,
        sgl_RoleId: this.userModel.sgL_RoleIdInt,
        sgl_Birth: this.userModel.sgL_Birth,
        sgL_Area: this.userModel.sgL_Area,
        sgL_LoginEmail: this.userModel.sgL_LoginEmail,
        sgL_NetworkDiskCapacity: this.userModel.sgL_NetworkDiskCapacity,
        photographerAuth: this.userModel.photographerAuth,
      };
      this.$api.permissionApi.UpdateUser(params).then((result) => {
        if (result.data.success == true) {
          this.IsUpdateUser = false;
          // this.$refs.featureModel.resetFields(); //清空表单
          this.getUserList();
          this.$message({
            type: "success",
            message: this.$t('message.operatesuccessfully'),
          });
        } else {
          this.$message({
            type: "warning",
            message: result.data.error.message,
          });
        }
      });
    },
    search() {
      this.handleCurrentChange(1);
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.getUserList();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.getUserList();
    },
  },
  components: {
    pagination,
  },
  computed: {
    GetListUser() {
      return this.userListModel;
    },
  },
};
</script>
<style scoped>
.margs {
  margin: 15px;
}
</style>>


// WEBPACK FOOTER //
// src/components/AdminUser/userList.vue